/**
 * Limite ÚNICO de upload (spec: "limite igual KB") — tickets e knowledge
 * importam daqui; duplicar o número nos dois módulos foi vetado em review.
 */
export const MAX_UPLOAD_BYTES = 25 * 1024 * 1024; // 25MB
